import React, { useState, useEffect, useContext } from 'react';
import { ActivityIndicator, Button, Platform, View, Text } from 'react-native';
import WebView from 'react-native-webview';
import ChatHeader from '../components/headers/ChatHeader';
import { ScrollView } from 'react-native-gesture-handler';
import { AuthContext } from '../contexts/auth/Store';
import Colors from '../constants/Colors';

const ChatScreen = () => {

    const auth = useContext(AuthContext)
    const buyer = auth.getUserData.buyerData

    const [loading, setLoading] = useState(false)
    const loaderSize = 40


    return <View style={{ flex: 1 }}>
        <ChatHeader />
        <ScrollView
            contentContainerStyle={{
                flex: 1,
                flexGrow: 1,
                overflow: "hidden",
            }}
        >
            {
                loading && <View
                    style={{
                        flex: 1,
                        justifyContent: 'center',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: -loaderSize / 2,
                        marginLeft: -loaderSize / 2,
                        zIndex: 1,
                    }}
                >
                    <ActivityIndicator color={Colors.shades._7} size={loaderSize} style={{ alignSelf: 'center' }} />
                </View>
            }
            {
                Platform.OS === 'android'
                    ? <WebView
                        source={{
                            // uri: 'https://secure.livechatinc.com/licence/12194496/v2/open_chat.cgi',
                            uri: `https://chat.suplias.com/buyer/${buyer.user_id}/${buyer._id}/${buyer.phone}/${buyer.name}/${buyer.location.name}/${buyer.address}`,
                        }}
                        style={{ opacity: 0.99 }}
                        onLoadStart={() => {
                            setLoading(true)
                        }}
                        onLoadEnd={() => {
                            setLoading(false)
                        }}
                    />
                    : null
            }
        </ScrollView>
    </View>
}

export default ChatScreen
